import { render, staticRenderFns } from "./documentActionsDialog.vue?vue&type=template&id=6fdcc61e&scoped=true"
import script from "./documentActionsDialog.vue?vue&type=script&lang=js"
export * from "./documentActionsDialog.vue?vue&type=script&lang=js"
import style0 from "./documentActionsDialog.vue?vue&type=style&index=0&id=6fdcc61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcc61e",
  null
  
)

export default component.exports